import toNumber from 'lodash/toNumber';
import { type OpenApiSchemaMediaItem } from '../../api/schema';

export const normalizeMediaSizes = (sizes: OpenApiSchemaMediaItem['sizes'] = []): { alias: string; width: number }[] =>
    sizes.map(({ alias, width = 0 }) => {
        return { alias, width: toNumber(width) };
    });
